import WidgetConfigMenu from 'scoreboard/dashboards/widgets/widget-config-menu'
import ChartDialogEditor from 'scoreboard/charts/edit/chart-dialog-editor'
import ChartDesigner from 'scoreboard/charts/model/chart-designer'
import appDisplay from 'scoreboard/components/app-display'
import _ from 'lodash'
import unwrapModel from 'scoreboard/components/unwrap-model'
import ChartData from 'scoreboard/charts/chart-data/chart-data'
import configWobBackground from 'scoreboard/dashboards/widgets/wob-background-menu'
import Label from 'scoreboard/dashboards/widgets/chart/config/chart-label'

var ChartWidgetConfigMenu = WidgetConfigMenu.extend({
	/** @type ChartWidgetModel */
	model: null,

	width: 200,

	initialize: function (opt) {
		WidgetConfigMenu.prototype.initialize.apply(this, arguments)
		this.options = opt
		this.getAccessoryWidget = this.options.getAccessoryWidget
	},

	typeSpecificTargets: function (hasTemplate) {
		let target = []

		target.push({
			type: 'dialog',
			label: 'charts.chart.edit',
			target: function (e) {
				const chartCopy = new ChartDesigner(
					_.cloneDeep(unwrapModel(this.model.chart)), {
						data: new ChartData({
							data: _.cloneDeep(this.model.chart.data._data),
							dashboardData: this.model.data
						})
					})
				const chartEditor = new ChartDialogEditor({
					model: chartCopy,
					liveFilters: this.model.maestro().liveFilters(),
					height: this.model.wob.get('height'),
					width: this.model.wob.get('width'),
					extraClass: 'chart-widget-dialog-editor'
				})

				appDisplay.dialog(chartEditor)

				chartEditor.once('done', ({ chartDesigner }) => {
					// For reasons that are unclear, Backbone will not update chart.data.
					// This must therefore be done prior to invoking the setter for chart
					// so that event handlers do not receive a stale chart data object.

					const edited =
						!_.isEqual(this.model.chart.attributes, chartDesigner.attributes)
					if (edited) {
						this.model.trigger('transaction', () => {
							this.model.chart.data = chartDesigner.data
							this.model.chart.freshRender = true
							this.model.set('chart', chartDesigner.attributes)
						})
					}
				})

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		})

		target.push({
			type: 'dialog',
			label: 'charts.setLabel',
			target: function (e) {
				var configView = new Label({
					model: this.model
				})

				appDisplay.dialog(configView)

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		})

		target.push(configWobBackground(this.model.properties))

		// #36717 options shown for charts with data tables
		if (this.model.chart.get('chartTable')) {
			// TODO Table-only options here
		}

		return target
	}
})

export default ChartWidgetConfigMenu

ChartWidgetConfigMenu.__filename__ = 'dashboards/widgets/chart/config/chart-widget-config-menu.js'
